<template>
    <div>
      认证详情
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>

</style>
